

import { createSlice } from '@reduxjs/toolkit';

const themeSlice = createSlice({
  name: 'thememode',
  initialState: {
    status: true // or 'false'
  },
  reducers: {
    lightTheme: state => {
      state.status = true;
    },
    darkTheme: state => {
        state.status = false;
      },
      resetTheme: state => {
        state.status = true; // Reset to light theme on logout
      }
  

  }
});



export const { lightTheme,darkTheme,resetTheme } = themeSlice.actions;
export const themeMode = state => state.thememode.status;
export default themeSlice.reducer;
